/**
 * Single source of truth for the brand surface.
 *
 * Myelina Health is the company/product brand (wordmark, nav, footer, meta, JSON-LD).
 * Myelina is the named in-product AI agent — an energy companion for people living with MS.
 * Use BRAND.agent.* when referring to the assistant inside the product.
 */
export const BRAND = {
  name: "Myelina Health",
  // Plain-text variant for places that need no trademark glyph (URLs, alt text, JSON-LD).
  nameSafe: "Myelina Health",
  legalName: "Myelina Health",
  tagline: "Predict your energy. Empower your life.",
  domain: "myelinahealth.com",
  url: "https://myelinahealth.com",
  shortDescription:
    "Myelina Health helps women living with MS see their energy patterns and plan the day around them — calmly, before fatigue decides for them.",
  twitter: "@myelinahealth",
  agent: {
    name: "Myelina",
    // Proper name — no acronym expansion.
    // Persona: personified as a quiet companion. Pronouns: she / her / hers.
    // In copy, prefer "Myelina notices…", "she reads…", "her forecast…".
    // Never refer to the agent as "it" or "the bot". "Myelina Health" (the
    // company/product) stays neutral — pronouns only apply to the agent.
    pronoun: "she",
    pronounPossessive: "her",
    intro: "Meet Myelina — she's your quiet energy companion.",
  },
} as const;
